import dialog from '@zzzj/zzzj/src/components/dialog';
export default dialog;